import { Route, Routes, Outlet } from "react-router-dom";
import Merchant from "../screens/Merchant";
import EmailVerificationsScreen from "../screens/Merchant/EmailVerificationsScreen";
import OnboardMerchantScreen from "../screens/Merchant/OnboardMerchantScreen";
import OnboardInitialScreen from "../screens/Merchant/OnboardInitialScreen";
import OnboardProfileScreen from "../screens/Merchant/OnboardProfileScreen";
import InvoicePreviewScreen from "../screens/Merchant/InvoicePreviewScreen";

const routes = [
  {
    path: "/verification/email/",
    element: <EmailVerificationsScreen />,
  },
  {
    path: "/merchant/kyc/onboarding",
    element: <OnboardMerchantScreen />,
  },
  {
    path: "/merchant/kyc/onboarding/initial",
    element: <OnboardInitialScreen />,
  },
  {
    path: "/merchant/kyc/onboarding/stepTwo",
    element: <OnboardProfileScreen />,
  },
  {
    path: "/merchant/*",
    element: <Merchant />,
  },
];

export default () => {
  return (
    <>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
        <Route
          path="/invoice/:invoiceNumber"
          element={<InvoicePreviewScreen />}
        />
      </Routes>

      <Outlet />
    </>
  );
};
